import NavBar from '../NavBar';

const AuthPage = ({ children, wide = false }) => (
  <div className="auth-page">
    <NavBar />
    <div className="auth-page__main">
      <div className={`auth-card${wide ? ' auth-card--wide' : ''}`}>
        {children}
      </div>
    </div>
  </div>
);

export default AuthPage;